<!--快速点击类组件-->
<template>
    <div class="SelectTourWrapper">
        <div class="selectWrapper">
            <RButton v-for="(item,ix) in list" :key="`tips-quick-${ix}`"
                     @on-click="()=>onAsk(item.name,item.value,item.id,item.toastType,item.children,item.selectType)"
                     color="selectTour">
                {{item.name}} <img src="../../assets/img/arrowTop.png" alt="向上折叠"
                                   class="arrowTop">
            </RButton>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import RButton from "../Use/r-button";

    export default {
        name: "SelectTour",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            show: {
                type: Boolean,
                default: true
            }


        },
        data() {
            return {
                isClick: true  //防止快速重复点击
            };

        },
        mounted() {

        },
        methods: {
            onAsk(name, value, id, toastType, children, selectType) {
                let that = this;
                if (this.isClick) {
                    this.isClick = false;
                    this.$emit("on-ask", name, value, id, toastType, children, selectType);
                    setTimeout(function () {
                        that.isClick = true;
                    }, 1000);
                }
            }
        }
    };
</script>
<style lang="less">
    .SelectTourWrapper {
        overflow: hidden;
        .selectWrapper {
            display: flex;
            justify-content:space-between;
            align-items: center;
        }

        .arrowTop {
            width: .45rem;
            height: .45rem;
            vertical-align: middle;
        }

    }

</style>
